import MuiSlider, { SliderProps } from '@mui/material/Slider';

export interface ISliderProps extends SliderProps {}

const Slider = (props: ISliderProps): JSX.Element => {
  return <MuiSlider {...props} />;
};

export default Slider;
